import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pushChipArrayAddCriteria, pushEntity, pushShowTable, pushAddCriteriaCard, applyingNewFilter } from '../../slices/customQueryBodySlice';
import { pushShowCard } from '../../slices/customQueryBodySlice';
import { pushEnableClearAll, showContextualPath } from '../../slices/customQueryHeaderSlice';
import { StyledButtonGroup, StyledButtonApply, StyledButtonCancel, StyledFilterCard, StyledFormedStringCard, TypographyText, StyledFormedButton } from './QueryStringStyle';
import RunIcon from '../../components/RunIcon/RunIcon';
import { resetOpenedAccordions } from '../../slices/entityCardSlice';
import { pushName } from '../../slices/customQueryBodySlice';
import consts from '../../utils/consts';
import { parseChipArray } from '../../utils/utils';
import { setSearchString } from '../../slices/customQuerySlice';

const QueryString = () => {
  const {
    operationsNamesArray,
    userAccountOperations
  } = consts;
  const queryStringArray = useSelector(state => state.customQueryBody.queryStringArray);
  const checkTableData = useSelector(state => state.customQueryBody.checkTableData);
  const selectedchipArray = useSelector(state => state.customQueryBody.selectedChipArray) || [];
  const existingChips = useSelector(state => state.customQueryBody.ChipArrayAddCriteria);
  const showCard = useSelector(state => state.customQueryBody.showCard);
  let formedChips;

  if (queryStringArray[0].length > 0) {
    let newArray;
    let formedString;

    if (selectedchipArray) {
      formedString = queryStringArray.join(' ');
      newArray = [...existingChips];
      newArray.push(formedString);
    }

    let unique = [...new Set(newArray)];
    formedChips = parseChipArray(unique, operationsNamesArray, userAccountOperations);
  } else {
    formedChips = existingChips.length > 0 ? parseChipArray(existingChips, operationsNamesArray, userAccountOperations) : '';
  }

  const [chipArray, setChipArray] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    let existingArray = [...chipArray];
    selectedchipArray.forEach(chip => {
      existingArray.push(chip);
    });
    let unique = [...new Set(existingArray)];
    setChipArray(unique);
  }, [selectedchipArray, showCard]);
  const onApplyQueryString = useCallback(() => {
    dispatch(pushAddCriteriaCard(true));
    dispatch(showContextualPath(false));
    dispatch(pushChipArrayAddCriteria(chipArray));
    dispatch(pushShowCard(false));
    dispatch(pushEnableClearAll(true));
    dispatch(resetOpenedAccordions());
    dispatch(pushName(''));
    dispatch(setSearchString(''));
    dispatch(applyingNewFilter(true));
  }, [queryStringArray, chipArray]);

  const onCancel = () => {
    dispatch(showContextualPath(false));
    dispatch(pushShowCard(false));
    dispatch(pushEntity([]));
    dispatch(pushShowTable(checkTableData));
    dispatch(pushAddCriteriaCard(true));
    dispatch(pushName(''));
    dispatch(resetOpenedAccordions());
    dispatch(setSearchString(''));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledFilterCard, {
    elevation: 0
  }, /*#__PURE__*/React.createElement(TypographyText, null, /*#__PURE__*/React.createElement("span", {
    className: "filter-txt"
  }, " Filters ")), /*#__PURE__*/React.createElement(StyledButtonGroup, null, /*#__PURE__*/React.createElement(StyledButtonApply, {
    onClick: onApplyQueryString,
    disabled: selectedchipArray.length === 0
  }, /*#__PURE__*/React.createElement(RunIcon, {
    className: "fas fa-play"
  }), "Apply"), /*#__PURE__*/React.createElement(StyledButtonCancel, {
    onClick: onCancel
  }, "Cancel"))), /*#__PURE__*/React.createElement(StyledFormedStringCard, {
    elevation: 0
  }, formedChips && formedChips.length > 0 ? formedChips.map((formedChip, index) => {
    let chipLabel = `${formedChip.entityName} ${formedChip.entityOpr} ${formedChip.entityValue}`;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledFormedButton, {
      key: index,
      color: "textSecondary",
      className: "pd-12 formed-str-txt"
    }, chipLabel), index === formedChips.length - 1 ? ' ' : /*#__PURE__*/React.createElement("span", null, "AND"));
  }) : ''));
};

export default QueryString;